module.exports = __webpack_public_path__ + "img/t4-i15.b2703f0e.jpg";